__turbopack_context__.v({
  "button": "WSsQUW_button",
  "lightMode": "WSsQUW_lightMode",
  "small": "WSsQUW_small",
});
